var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"placeholder":_vm.placeholder,"color":"black","rules":_vm.rules},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }